import { createFileRoute } from "@tanstack/react-router";
/**
 * EntityVisibility Page
 *
 * Sets Entities whose products you can see (for practices)
 * and Entities who can see your products (for pharmacies/fulfillers)
 *
 * The entityId param is required.
 */
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetEntityQueryOptions } from "@/requests/gen/react-query/entity";
import EntityVisibilityForm from "./-form";
import { EntityCrumbs } from "../../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_admin/entity/$entityId/visibility/",
)({
  loader: ({ context: { queryClient }, params: { entityId } }) =>
    queryClient.ensureQueryData(getGetEntityQueryOptions(numericId(entityId))),
  component: EntityVisibilityPage,
});

function EntityVisibilityPage() {
  const { entityId } = Route.useParams();
  // Fetch the entity data
  const { data: entity } = useSuspenseQuery(
    suspenseOptions(getGetEntityQueryOptions(numericId(entityId))),
  );

  return (
    <div>
      <title>{`Edit ${entity?.name} Visibility - Legrande Health Portal`}</title>
      <EntityCrumbs />

      {/* Entity form */}
      <Card>
        <CardHeader>
          <CardTitle>Set Visible Entities</CardTitle>
          <CardDescription>Set visible entities</CardDescription>
        </CardHeader>
        <CardContent>
          {entity && <EntityVisibilityForm entity={entity} />}
        </CardContent>
      </Card>
    </div>
  );
}
